import React, {useContext} from 'react';
import {Col, FormGroup, Input, Label, PopoverBody, Row, UncontrolledPopover} from "reactstrap";
import {Switch} from "../../../../generic/buttons";
import PropTypes from 'prop-types';
import HideUntilField from "../../../../common/formElements/hideUntilField";
import {t} from "i18next";
import ElementWithAccessInCountries from '../../../../../lib/utils/hocs/ElementWithAccessInCountries';
import TelegramOptions from '../../../../common/formElements/TelegramOptions';
import {TextControllerRHF} from "../../../../generic/fields";
import TextAreaJsonBlock from "../../../../common/formElements/TextAreaJsonBlock";
import {FaInfoCircle} from "react-icons/fa";
import {GlobalSettingsState} from "../../../../../lib/api/globalSettingsProvider"
import InsuranceTooltip from "../../../../generic/tooltips/InsuranceTooltip";
import InfoTooltip from "../../../../generic/InfoTooltip";

const Settings = ({state, dispatch, control, errors, isSlot = false}) => {
    const setData = e => dispatch({type: 'setFormData', payload: e});
    const {globalSettings} = useContext(GlobalSettingsState);
    const insuranceBase = state?.base_id?.insurance || state?.base?.insurance;
    const isNotInsurance = !insuranceBase || !globalSettings.insurance_available || !globalSettings.insurance_available_sport;

    const handleCheckboxInversion = (event) => {
        setData({
            target: {
                name: event.target.name,
                type: event.target.type,
                checked: !event.target.checked,
            }
        })
    };

    return <>
        <Row className={'mb-3'}>
            <Col>
                <h5 className={'display-4'}>{t('bases.base.settings')}</h5>
            </Col>
        </Row>
        <Row>
            <Col xs={12} md={8}>
                <Label>{t('bases.base.hideEventPlace.title')}</Label>
                <InfoTooltip text={t('bases.base.hideEventPlace.info')}/>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={!state.hide_event_place} name={'hide_event_place'} onChange={handleCheckboxInversion}/>
            </Col>
            <div className='settings-divider'/>
            <Col xs={12} md={8}>
                <Label>{t('bases.base.insurance')}</Label>
                <InsuranceTooltip type="sport"/>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.insurance !== false && !isNotInsurance} name={'insurance'} onChange={setData}
                        disabled={isNotInsurance}/>
            </Col>
            <div className='settings-divider'/>
            <Col xs={12} md={8}>
                <Label>{t('bases.base.confirmParticipantData')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.confirm_participant_data} name={'confirm_participant_data'} onChange={setData}/>
            </Col>
            {
                state?.confirm_participant_data &&
                <>
                    <Col xs={9} className={'mt-1 mb-1'}>
                        <FormGroup>
                            <TextAreaJsonBlock control={control} dispatch={dispatch} isRequired={false}
                                                defaultValue={state?.participant_data_info} name={'participant_data_info'}
                                                label={t('common.forms.participantDataRequired.lableDataParticipant')}
                                                placeholder={t('common.forms.participantDataRequired.placeholder')}/>
                        </FormGroup>
                    </Col>
                    <div className='settings-divider'/>
                    <Col xs={12} md={8}>
                        <Label>{t('bases.base.briefDataEntry')}</Label>
                        <FaInfoCircle className='ml-1' id={"brief_data_entry-legend_i"}/>
                        <UncontrolledPopover placement="right" target={"brief_data_entry-legend_i"} trigger={'hover'}>
                            <PopoverBody>
                                {t('bases.base.briefDataEntryFaInfo')}
                            </PopoverBody>
                        </UncontrolledPopover>
                    </Col>
                    <Col xs={12} md={2}>
                        <Switch value={state.brief_data_entry} name={'brief_data_entry'} onChange={setData}/>
                    </Col>
                </>
            }
            <div className='settings-divider'/>
            <ElementWithAccessInCountries hideInCountries={['EN']}>
                <Col xs={12} md={8}>
                    <Label>{t('bases.base.registerWithoutInstructor')}</Label>
                </Col>
                <Col xs={12} md={2}>
                    <Switch value={state.is_coach_required} name={'is_coach_required'} onChange={setData}/>
                </Col>
                <div className='settings-divider'/>
            </ElementWithAccessInCountries>
            {(state?.boat_class === 'luch' || state.event_id?.boat_class === 'luch') &&
                <ElementWithAccessInCountries hideInCountries={['EN']}>
                    <Col xs={12} md={8}>
                        <Label>{t('bases.base.registerOwnBoat')}</Label>
                    </Col>
                    <Col xs={12} md={2}>
                        <Switch value={state.is_own_boat} name={'is_own_boat'} onChange={setData}/>
                    </Col>
                    <div className='settings-divider'/>
                </ElementWithAccessInCountries>}
            <Col xs={12} md={8}>
            <Label>{t('bases.base.rentFullBoat')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.is_full_book_available} name={'is_full_book_available'}
                        onChange={e => {
                            setData(e)
                            state.is_full_book_available && dispatch({type: 'clearDiscountData', payload: 'full_book'})
                        }}/>
            </Col>
            <div className='settings-divider'/>
            <ElementWithAccessInCountries hideInCountries={['EN']}>
                <Col xs={12} md={8}>
                    <Label>{t('bases.base.instructorSelector')}</Label>
                </Col>
                <Col xs={12} md={2}>
                <Switch value={state.is_coach_selectable} name={'is_coach_selectable'} onChange={setData}/>
                </Col>
                <div className='settings-divider'/>
            </ElementWithAccessInCountries>


            <Col xs={12} md={8}>
                <Label>{t('bases.base.subscriptionPay')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.promo_subscription_available} name={'promo_subscription_available'}
                        onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.onlyTeam')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.team_only} name={'team_only'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.onlyLink')}</Label>
                <InfoTooltip text={t('bases.base.onlyLinkInfo')}/>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.is_private} name={'is_private'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            {state.id && <>
                <Col xs={12} md={8}>
                    <Label>{isSlot ? t('bases.base.slotClosed') : t('bases.base.eventClosed')}</Label>
                </Col>
                <Col xs={12} md={2}>
                    <Switch value={state.is_closed} name={'is_closed'} onChange={setData}/>
                </Col>
                <div className='settings-divider'/>
            </>}

            <Col xs={12} md={8}>
                <Label>{t('bases.base.checkAge')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.check_age_required} name={'check_age_required'} onChange={setData}/>
            </Col>
            {state.check_age_required ? <>
                <Col sm={5} className={'mt-1 mb-3'}>
                    <Label>{t('bases.base.age')}</Label>
                    <Input type={state.check_age_value} name={'check_age_value'} value={state.check_age_value}
                           onChange={setData} placeholder={'16'}/>
                </Col>
            </> : <div className='settings-divider'/>
            }

            <Col xs={12} md={8}>
                <Label>{t('bases.base.showBookingLimit')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.show_booking_limit} name={'show_booking_limit'} onChange={setData}/>
            </Col>
            {state.show_booking_limit ? <>
                <Col sm={5} className={'mt-1 mb-3'}>
                    <FormGroup>
                        <TextControllerRHF inputName={'corporate_offer_quantity'} control={control} type={'number'} isRequired={true}
                                            setValue={setData} placeholder={'16'} label={t('bases.base.corporate_offer_quantity')}
                                            errors={errors} defaultValue={state.corporate_offer_quantity || ''} 
                                            rules={{required: t('inputs.validation.required')}}/>
                    </FormGroup>
                </Col>
            </> : <div className='settings-divider'/>
            }


            <Col xs={12} md={8}>
                <Label>{t('bases.base.hideUntil')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.hide_until_enabled} name={'hide_until_enabled'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.singleBooking')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.single_booking} name={'single_booking'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.disablePromo')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.disable_promo} name={'disable_promo'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.paidLocally')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Switch value={state.paid_locally} name={'paid_locally'} onChange={setData}/>
            </Col>
            <div className='settings-divider'/>

            <Col xs={12} md={8}>
                <Label>{t('bases.base.tg_options')}</Label>
            </Col>
            <Col xs={12} md={2} className='mb-3'>
                <TelegramOptions tg_options={state.tg_options} onChange={setData}/>
            </Col>
            {
                state?.hide_until_enabled &&
                <Col xs={12} md={8}>
                    <FormGroup>
                        <HideUntilField errors={errors} defaultValue={state?.hide_until_time || 0}
                                        control={control} setValue={setData}/>
                    </FormGroup>
                </Col>
            }

            <Col xs={12} md={8}>
                <Label>{t('bases.base.color')}</Label>
            </Col>
            <Col xs={12} md={2}>
                <Input bsSize={'sm'} type={'color'} value={state.calendar_color || '#000000'} name={'calendar_color'}
                       onChange={setData}/>
            </Col>
        </Row>
    </>
}

export default Settings;

Settings.propTypes = {
    state: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
}